import * as React from 'react';
import * as styles from './styles.css';

import cn from 'classnames';
import { Header4, Paragraph1, Star16, Image } from '@cian/ui-kit';

export interface IRealtorCardProps {
  isBig?: boolean;
  name: string;
  rating: string;
  reviews: string;
  img: string;
}

export const RealtorCard: React.FC<IRealtorCardProps> = ({ isBig, name, rating, reviews, img }) => {
  const imgSize = isBig ? '100px' : '60px';

  return (
    <div className={cn(styles['card'], isBig && styles['card-big'])}>
      <div>
        <div className={styles['card-title']}>
          <Header4>{name}</Header4>
        </div>
        <div className={styles['card-content']}>
          <div className={styles['rating']}>
            <Star16 color="warning_100" />
            <div className={styles['rating-value']}>
              <Header4 color="warning_100">{rating}</Header4>
            </div>
          </div>
          <div className={styles['reviews']}>
            <Paragraph1>{reviews}</Paragraph1>
          </div>
        </div>
      </div>
      <div className={styles['img']}>
        <Image src={img} width={imgSize} height={imgSize} borderRadius="50%" />
      </div>
    </div>
  );
};

RealtorCard.displayName = 'RealtorCard';
